<template>
  <Head :title="`${user.name}`" />

  <BreezeAuthenticatedLayout>
    <main class="container" id="users_accomplish">
      <div class="main">

        <div class="header_chara_wrapper">
          <figure class="header_chara_wrapper_avatar">
            <img :src="`/images/char/${ charaFileName }.gif`">
          </figure>
          <div class="header_chara_wrapper_message" v-if="!is_level_up">
            YOU WIN!
          </div>
          <div class="header_chara_wrapper_message level-up" v-else>
            LEVEL UP!
          </div>
          <div class="header_chara_wrapper_level">
            <div class="header_chara_wrapper_level_heading">LEVEL {{ user.level }}</div>
            <div class="header_chara_wrapper_level_bar" v-if="!is_level_up">
              <span class="header_chara_wrapper_level_bar_exp" :style="{ width: prevExpPercent*100+'%' }"></span>
              <span class="header_chara_wrapper_level_bar_incremental" :style="{ width: addExpPercent*100+'%', left: prevExpPercent*100+'%' }"></span>
            </div>
            <div class="header_chara_wrapper_level_bar" v-else>
              <span class="header_chara_wrapper_level_bar_exp" :style="{ width: 100-expPercent*100+'%' }"></span>
              <span class="header_chara_wrapper_level_bar_incremental" :style="{ width: ((user.exp - levelExpNext)/(levelExpAfterNext - levelExpNext)+1)+'%', left: 0 }"></span>
            </div>
            <div class="header_chara_wrapper_level_point" v-if="!is_level_up">
              NEXT LEVEL : {{ user.exp - levelExp }}/{{ levelExpNext - levelExp}}
            </div>
            <div class="header_chara_wrapper_level_point" v-else>
              NEXT LEVEL : {{ user.exp - levelExpNext }}/{{ levelExpAfterNext - levelExpNext}}
            </div>
            <div class="header_chara_wrapper_level_point">
              + {{ add_exp }} EXP
            </div>
            <div class="header_chara_wrapper_level_exp">
              EXP : {{ $page.props.auth.user.exp }}
            </div>
          </div>
          <div class="header_chara_wrapper_next">
            <Link :href="`/gyms/${slug}/${grade_id}`">&gt;</Link >
          </div>
        </div>

      </div>
    </main>
  </BreezeAuthenticatedLayout>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  // import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      Inertia,
      // Side,
    },

    props: {
      user: Object,
      slug: String,
      grade_id: String,
      levelExp: String,
      levelExpNext: String,
      levelExpAfterNext: String,
      add_exp: String,
      is_level_up: Boolean,
      expPercent: String,
      prevExpPercent: String,
      addExpPercent: String,
      charaFileName: String,
    },
  }
</script>
